@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.grid-loading {
  height: 100%;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  background-color: @grid-loading--background-color;
}
